import React, { useEffect, useState } from "react";
import { Table, Button, Row, Col, Typography, Tag } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchInsuranceReceipts,
  deleteInsuranceReceipt,
} from "./insuranceReceiptThunk";

import {
  resetInsuranceReceipts,
  setSelectedInsuranceReceipt,
  setIsEditInsuranceReceipt,
} from "./insuranceReceiptSlice";

import dayjs from "dayjs";
import commaNumber from "comma-number";
import { getAccessType } from "../../lib/functions";

const format = commaNumber.bindWith(",", ".");

const InsuranceReceiptList = () => {
  const { Title } = Typography;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { receipts, loading } = useSelector((s) => s.insuranceReceipts);
  let [access_type, access_type_set] = useState("");

  useEffect(() => {
    access_type_set(getAccessType("debtor_receipt"));
  }, []);

  useEffect(() => {
    dispatch(resetInsuranceReceipts());
    dispatch(fetchInsuranceReceipts());
  }, [dispatch]);

  const columns = [
    {
      title: "No.",
      render: (_, __, index) => index + 1,
      width: 60,
    },
    {
      title: "Receipt Code",
      dataIndex: "rcv_code",
    },
    {
      title: "Receipt Date",
      dataIndex: "created_date",
      render: (value) => (value ? dayjs(value).format("DD-MMM-YYYY") : "-"),
    },
    {
      title: "Insurance",
      render: (_, record) =>
        record.details && record.details.length > 0
          ? record.details[0].from_acc_name
          : "",
    },
    {
      title: "Total Discount",
      dataIndex: "discount_total",
      align: "right",
      render: (val) => Number(val || 0).toFixed(2),
    },
    {
      title: "Received Total",
      dataIndex: "rcv_total",
      align: "right",
      render: (val) => Number(val || 0).toFixed(2),
    },
    {
      title: "Description",
      dataIndex: "narration",
    },
    {
      title: "Created By",
      dataIndex: "full_name",
    },
    // Uncomment when edit allowed:
    // {
    //   title: "Actions",
    //   render: (_, record) => (
    //     <Button
    //       type="link"
    //       onClick={() => {
    //         dispatch(setSelectedInsuranceReceipt(record));
    //         dispatch(setIsEditInsuranceReceipt(true));
    //         navigate(`/accounts/debitor-insurance-receipts/edit/${record.rcv_id}`);
    //       }}
    //     >
    //       Edit
    //     </Button>
    //   ),
    // },
  ];

  const detailColumns = [
    {
      title: "Sl No.",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    { title: "RECEIVED INTO", dataIndex: "into_acc_name" },

    {
      title: "Amount",
      dataIndex: "rcv_amount",
      align: "right",
      render: (val) => format(Number(val || 0).toFixed(2)),
    },

    {
      title: "Status",
      dataIndex: "payment_status",
      align: "center",
      render: (val) => {
        const color =
          val === "approved"
            ? "green"
            : val === "rejected"
            ? "red"
            : "gold";
        return (
          <Tag color={color}>
            {val.charAt(0).toUpperCase() + val.slice(1)}
          </Tag>
        );
      },
    },
  ];

  return (
    <>
      <Title level={3}>Insurance Receipts</Title>

      <Row justify="end" style={{ marginBottom: 32, marginTop: 32 }}>
        <Col>
          {access_type === "WRITE" && (
            <Button
             data-testid="insurance-add-receipt"
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => navigate("/accounts/debitor-insurance-receipts/add")}
            >
              Add New
            </Button>
          )}
        </Col>
      </Row>

      <Table
        bordered
        loading={loading}
        columns={columns}
        dataSource={receipts}
        rowKey={(rec, index) => `${rec.rcv_id}-${index}`}
        pagination={{ pageSize: 10 }}
        size="middle"
        scroll={{ x: "max-content" }}
        expandable={{
          expandedRowRender: (record) => {
            return (
              <Table
                rowKey="detailId"
                columns={detailColumns}
                dataSource={record.details || []}
                pagination={false}
                size="small"
                bordered
              />
            );
          },
        }}
        style={{
          border: "1px solid #f0f0f0",
          borderRadius: 8,
          overflow: "hidden",
          backgroundColor: "#fff",
        }}
        rowClassName={(_, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
      />
    </>
  );
};

export default InsuranceReceiptList;
